import React from "react";
import { HomeOutlined, UserOutlined } from "@ant-design/icons";
import { Breadcrumb, Button, Form, Input } from "antd";
import "./warehouse.css";
import withWarehouseLogic, { InjectedWarehouseProps } from '../../components/hoc_warehouse';

const DataWarehouse: React.FC<InjectedWarehouseProps> = ({
    warehouseData,
    handleInputChange,
    handleSave
}) => {
    const transformStyle = {
        transform: "scale(0.80)",
        transformOrigin: "top left",
        width: "125%",
    };

    return (

        <div id="iklk" style={transformStyle}>
            <div className="gjs-grid-row" id="ipot">
                <div className="gjs-grid-column" id="ilh4">
                    <Breadcrumb
                        items={[
                            {
                                title: <HomeOutlined />,
                            },
                            {
                                href: "#/dashboard/browser_warehouse",
                                title: (
                                    <>
                                        <UserOutlined />
                                        <span>Data Warehouse</span>
                                    </>
                                ),
                            },
                            {
                                title: "Warehouse",
                            },
                        ]}
                    />
                </div>
            </div>

            <div className="gjs-grid-row" id="idwh">
                <div className="gjs-grid-column" id="iaqj">
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875ZM12.75 12a.75.75 0 0 0-1.5 0v2.25H9a.75.75 0 0 0 0 1.5h2.25V18a.75.75 0 0 0 1.5 0v-2.25H15a.75.75 0 0 0 0-1.5h-2.25V12Z" clipRule="evenodd" />
                            <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                        </svg> New
                    </Button>
                    <Button className="pr-button" onClick={handleSave}>
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z" clipRule="evenodd" />
                        </svg> Save
                    </Button>
                    <Button className="pr-button">
                        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: '1em', height: '1em', marginRight: '8px' }}>
                            <path fillRule="evenodd" d="M19.5 21a3 3 0 0 0 3-3V9a3 3 0 0 0-3-3h-5.379a.75.75 0 0 1-.53-.22L11.47 3.66A2.25 2.25 0 0 0 9.879 3H4.5a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h15Zm-6.75-10.5a.75.75 0 0 0-1.5 0v4.19l-1.72-1.72a.75.75 0 0 0-1.06 1.06l3 3a.75.75 0 0 0 1.06 0l3-3a.75.75 0 1 0-1.06-1.06l-1.72 1.72V10.5Z" clipRule="evenodd" />
                        </svg> Status
                    </Button>
                </div>
            </div>

            <div className="gjs-grid-row" id="iwfqs">
                <div className="gjs-grid-column" id="idz9l">
                    <Form
                        layout="horizontal"
                        style={{ maxWidth: 500 }}
                        labelCol={{ style: { width: '220px', textAlign: "left" } }}
                        wrapperCol={{ style: { width: '290px' } }}
                        className="custom-info-purchase-request"
                    >
                        <Form.Item label="Dealer Code" style={{ marginBottom: "5px" }}>
                            <div style={{ display: "flex", gap: "10px", alignItems: "center" }}>
                                <Input
                                    name="dealer_code" 
                                    placeholder="Dealer code"
                                    style={{ width: "50%" }}
                                    value={warehouseData?.dealer_code} 
                                    onChange={handleInputChange} 
                                />
                                <Button type="primary" icon={
                                    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={{ width: "40px", height: "20px" }}>
                                        <path d="M11.625 16.5a1.875 1.875 0 1 0 0-3.75 1.875 1.875 0 0 0 0 3.75Z" />
                                        <path fillRule="evenodd" d="M5.625 1.5H9a3.75 3.75 0 0 1 3.75 3.75v1.875c0 1.036.84 1.875 1.875 1.875H16.5a3.75 3.75 0 0 1 3.75 3.75v7.875c0 1.035-.84 1.875-1.875 1.875H5.625a1.875 1.875 0 0 1-1.875-1.875V3.375c0-1.036.84-1.875 1.875-1.875Zm6 16.5c.66 0 1.277-.19 1.797-.518l1.048 1.048a.75.75 0 0 0 1.06-1.06l-1.047-1.048A3.375 3.375 0 1 0 11.625 18Z" clipRule="evenodd" />
                                        <path d="M14.25 5.25a5.23 5.23 0 0 0-1.279-3.434 9.768 9.768 0 0 1 6.963 6.963A5.23 5.23 0 0 0 16.5 7.5h-1.875a.375.375 0 0 1-.375-.375V5.25Z" />
                                    </svg>}
                                />
                            </div>
                        </Form.Item>
                        <Form.Item
                            label="Dealer Name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input name="dealer_name"
                                placeholder=""
                                readOnly
                                value={warehouseData?.dealer_name}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse Name"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                name="warehouse_name"
                                placeholder=""
                                value={warehouseData?.warehouse_name}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Address Warehouse"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input.TextArea
                                name="address"
                                placeholder=""
                                rows={6}
                                value={warehouseData?.address}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse Contact Person"
                            style={{
                                marginBottom: "5px",
                            }}
                        >
                            <Input
                                name="contact_person"
                                placeholder=""
                                value={warehouseData?.contact_person}
                                onChange={handleInputChange}
                            />
                        </Form.Item>
                        <Form.Item
                            label="Warehouse Status"
                            style={{
                                marginBottom: "5px", width: "67%"
                            }}
                        >
                            <Input
                                placeholder=""
                                readOnly
                                value={warehouseData?.status === 1 ? 'Active' : 'Deactive'}
                            />
                        </Form.Item>
                    </Form>

                </div>
            </div>
        </div>
    );
};

export default withWarehouseLogic(DataWarehouse);
